// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"14d76419","453":"e70c4ae6"}[chunkId] + ".chunk.js";
};